module.exports = __webpack_public_path__ + "assets/media/button.3cede20e.mp3";